export default function (msisdn, serviceId) {
    sessionStorage.setItem('msisdn', msisdn)
    sessionStorage.setItem('serviceId', serviceId)
}
